export default function Testimonials() {
  const reviews = [
    {
      name: 'Marcus R.',
      role: 'Verified Buyer, USA',
      text: 'Finally a spreadsheet directory that actually stays updated. Found my go-to Nike seller through here and have placed 5 orders since. The category breakdown saves so much time.',
      avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20adult%20male%20with%20warm%20natural%20lighting%20on%20light%20cream%20background%20clean%20minimalist%20style%20friendly%20expression&width=100&height=100&seq=testimonial-01&orientation=squarish',
    },
    {
      name: 'Lena K.',
      role: 'Community Member, Germany',
      text: 'I was completely lost with CSSBuy until I found this site. The beginner guide walked me through everything, and the spreadsheet links actually work. Game changer for European buyers.',
      avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20adult%20female%20with%20warm%20natural%20lighting%20on%20light%20cream%20background%20clean%20minimalist%20style%20friendly%20expression&width=100&height=100&seq=testimonial-02&orientation=squarish',
    },
    {
      name: 'David T.',
      role: 'Frequent Buyer, UK',
      text: 'Compare section is brilliant. Switched from Superbuy to CSSBuy after reading the comparison and saved about 30% on shipping. Spreadsheet links are always fresh.',
      avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20adult%20male%20with%20warm%20natural%20lighting%20on%20light%20cream%20background%20clean%20minimalist%20style%20friendly%20expression&width=100&height=100&seq=testimonial-03&orientation=squarish',
    },
    {
      name: 'Sophie M.',
      role: 'Haul Reviewer, Canada',
      text: 'Best resource for anyone into agent shopping. The brand pages make finding specific items so easy. And everything is free — no paywalls, no premium tiers.',
      avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20adult%20female%20with%20warm%20natural%20lighting%20on%20light%20cream%20background%20clean%20minimalist%20style%20friendly%20expression&width=100&height=100&seq=testimonial-04&orientation=squarish',
    },
    {
      name: 'Jay W.',
      role: 'Streetwear Collector, Australia',
      text: 'Been using these spreadsheets for 6 months now. The daily updates are legit — new links appear constantly and dead ones disappear. Trusted seller badges are accurate too.',
      avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20adult%20male%20with%20warm%20natural%20lighting%20on%20light%20cream%20background%20clean%20minimalist%20style%20friendly%20expression&width=100&height=100&seq=testimonial-05&orientation=squarish',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-medium text-primary-600 tracking-widest uppercase">Community Favorites</span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mt-3 leading-tight">
            Trusted Reviews
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            See what real buyers say about using our CSSBuy spreadsheet directory.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {reviews.map((review) => (
            <div key={review.name} className="p-6 md:p-7 bg-background-100 rounded-lg border border-background-200/70">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={review.avatarUrl}
                    alt={review.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{review.name}</p>
                  <p className="text-xs text-foreground-500 whitespace-nowrap">{review.role}</p>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm text-accent-400 w-4 h-4 flex items-center justify-center"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{review.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}